import React, { useState } from 'react';
import { startCase } from 'lodash';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import { useTranslation } from 'react-i18next';
import Modal from '~/commons/components/Modal.jsx';

const toConfirm = 'DEACTIVATE ALL';

const ModalUDeactConfirm = ({
  show,
  deactivateWho,
  onReject = () => { },
  onConfirm = () => { },
}) => {
  const [confirmText, setConfirmText] = useState('');
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onReject}
      centered
    >
      <div className="p-4">
        <h4 className="text-danger">
          <FA icon={faExclamationTriangle} size="lg" />
        </h4>
        <h6 className="mt-3">
          <strong>
            {t(`DisactiveAll${startCase(deactivateWho)}1`)}
          </strong>
        </h6>
        <p>
          {t(`DisactiveAll${startCase(deactivateWho)}2`)}
          <br />
          {t(`DisactiveAll${startCase(deactivateWho)}3`)}
        </p>
        <h2>{t('Are you sure?')}</h2>

        <p>{t('TypeToConfirm1')}<strong>{toConfirm}</strong>{t('TypeToConfirm2')}</p>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            onChange={(e) => setConfirmText(e.target.value)}
          />
        </div>
        <div className="form-group">
          <button
            className="btn btn-block btn-danger"
            onClick={onConfirm}
            disabled={confirmText !== toConfirm}
          >
            {t('Confirm')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalUDeactConfirm;
